import axios from "axios";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

const SESSION_KEYS_TO_CLEAR = [
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  "email",
  "name",
  "subscribed_products",
  "subscribed_products_start_dates",
  "subscribed_products_end_dates",
  "trial_info",
];

interface JwtPayload {
  exp?: number;
}

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const clearAuthSession = (): void => {
  SESSION_KEYS_TO_CLEAR.forEach((key) => localStorage.removeItem(key));
};

export const isTokenExpired = (
  token: string,
  expiryBufferSeconds = 20,
): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1])) as JwtPayload;
    if (!payload.exp) {
      return true;
    }

    const now = Date.now() / 1000;
    return payload.exp <= now + expiryBufferSeconds;
  } catch {
    return true;
  }
};

export const refreshAccessToken = async (): Promise<string> => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    throw new Error("Refresh token is missing");
  }

  const response = await axios.post(
    `${process.env.REACT_APP_BASEURL}/users/auth/token/refresh/`,
    { refresh: refreshToken },
  );

  const newAccessToken = response.data?.access || response.data?.accessToken;

  if (!newAccessToken) {
    throw new Error("Refresh endpoint did not return an access token");
  }

  setAccessToken(newAccessToken);
  return newAccessToken;
};
